
<div class="loader">
    <div class="dimmed"  [hidden]="status != LOADING">
        <div class="dimmed_box"></div>
    </div>
</div>
<div *ngIf="status == DONE">
    <ul class="version-related-item">
        <li *ngFor="let version of related.versions; trackBy: trackByFn" >
            <!-- here we use the new nov-2022 app component with status update-->
            <versions-summary-status-box 
                [version]="version"
                [exclude]="project.labels"
                [uploaded]="uploadedCheck(version)"
                [menu]="menu"
                [feedbacks]="getFeedbacks(version)"
                (menuClick)="onMenuClick($event)"
                (menuStatusClick)="updateVersionStatus($event,version)"
                (actionFileClick)="onFileClick(version,$event)"
            ></versions-summary-status-box>
        </li>
    </ul>
</div> 
